import { apiRequest, CompletedApiRequest } from './_tools';
import { Summary } from 'common/dist/types/habitat';

export function fetchSummary(): CompletedApiRequest<Summary> {
  return apiRequest('/api/models/summary/');
}
